module.exports = __webpack_public_path__ + "static/media/ahi-pi-low-risk.618a1341.svg";